module.exports = __webpack_public_path__ + "static/img/loading.1839eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.png
// module id = Yyfi
// module chunks = 3